import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetSectionTemplate,
  useSectionTemplatesLightListByKind,
} from 'services/templates/section-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { isParagraphCustomSection } from 'utils/components/contract-template/section/customSection.utils';
import { addItem, getExtremeId } from 'utils/dnd/dndUtilities';

const ContractSideMenuParagraphSectionsList = () => {
  const { values, setFieldValue, namePrefix, setErrors } =
    useFormikContractHelpers();

  const sectionTemplateList = useSectionTemplatesLightListByKind('paragraph');

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const sectionTemplate = useGetSectionTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (
      !!selectedId &&
      sectionTemplate.data &&
      parentId &&
      isParagraphCustomSection(sectionTemplate.data.type)
    ) {
      const contractTemplateForm = middleware.template.section.queryToForm(
        sectionTemplate.data,
        `${parseInt(getExtremeId(values.items)) + 1}`
      );

      const section = contractTemplateForm[0].children[0];

      if (contractTemplateForm) {
        setFieldValue(namePrefix, addItem(values.items, parentId, section));
        setFieldValue('sideMenu.customTemplate.selectedId', undefined);
        setErrors({});
      }
    }
  }, [selectedId, sectionTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={sectionTemplateList.data}
      templateType={TEMPLATE_TYPE.paragraphSection}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuParagraphSectionsList;
